import React,{useCallback, useMemo} from "react";
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Badge, Avatar as Muiavatar, IconButton } from "@mui/material";
import { EditOutlined, DeleteOutlined, MoreVert } from "@mui/icons-material";

import EditTextFields from "../editComment/editComment";
import { deleteComment } from "../../../../../../sevices/apiComment";
import CustomDateFormatter from "../../../dateTimeFormateConverter/dateTimeFormateConverter";
import { currentUserId } from "../../../../../../utils/constants";
import Avatar from "../../../../../../components/Avatar";
import GetHeadShotName from "../../../../../../utils/getHeadShotName";
import { hasImage } from "../../../../../../utils";
import WorklogText from "../../../worklog/worklogTextEditor";
import CommentIcon from "../../../../../../styles/svg/coment-icon.svg";
import { useResponsive } from "../../../../../../hooks/useResponsive";
import FormDialog from "../../../../../../components/Dialog/FormDialog";
import { CustomButton } from "../../../../../../components/Button/Button";
import useMutate from "../../../../../../hooks/useMutate";
import CustomMenu from "../../../../../../components/Menu";
import CustomMenuItem from "../../../../../../components/Menu/CustomMenuItem";

const SmallAvatar = styled(Muiavatar)(({ theme }) => ({
  width: 16,
  height: 16,
  border: `2px solid ${theme.palette.background.paper}`,
}));

function ListComment({ data, cardId, showIcon = false }) {
  const queryClient = useQueryClient();
  const isMobile = useResponsive("down", "md");
  const isBetween300And699 = useResponsive("between", 300, 699);
  const [loading, setLoading] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const headShotName = GetHeadShotName(data?.username);
  const [anchorEl, setAnchorEl] = useState(null);
  
  const { mutate: deleteCommentMutate } = useMutate(deleteComment,[],
    ()=>{},
    () => {
      queryClient.invalidateQueries({
        queryKey: [`comment`, cardId],
      });
      queryClient.invalidateQueries({
        queryKey: [`history`, String(cardId)],
      });
      setLoading(false);
      handleClose();
    },
    () => {
      setLoading(false);
      handleClose();
    },
  );

  const handleEdit = useCallback(() => {
    setShowEdit(true);
  }, []);

  const handleDelete = useCallback(() => {
    setShowDelete(true);
  }, []);

  const handleClose = useCallback(() => {
    setShowDelete(false);
  }, []);

  const callback = useCallback(() => {
    setLoading(true);
    deleteCommentMutate(data.comment_id);
  }, [deleteCommentMutate, data.comment_id]);


  const avatarStyle = useMemo(() => (
    !hasImage(data.user_image) && {
      bgcolor: data?.user_profile_color?.background,
      color: data?.user_profile_color?.text,
    }
  ), [data]);

  return (
    <>
      {showDelete && (
        <FormDialog
          open={showDelete}
          handleClose={handleClose}
          handleSubmit={callback}
          loading={loading}
          buttonTxt={"Delete"}
          title={"Confirmation: Delete Confirmation"}
          alignActions={"center"}
          cancelBtn={true}
          fullWidth={true}>
          <Typography className="align_text_center mb-2">
            Are you sure to you want to delete this item? This action can not be
            undone
          </Typography>
        </FormDialog>
      )}
      <Box
        sx={{
          flexGrow: 1,
          px: isMobile && "",
          pl: isMobile ? 1 : "",
          width: isMobile ? "96%" : "100%",
        }}>
        <Grid container spacing={2} className="comment-container">
          <div className={isMobile ? "mobile-comment-box" : "comment-box"}>
            <Grid>
              {showIcon ? (
                <Badge
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  badgeContent={
                    <SmallAvatar alt="Remy Sharp" src={CommentIcon} />
                  }>
                  <Avatar
                    title={data?.username}
                    className={
                      " header-avatar add-comment-avtar comment-box-img"
                    }
                    user_image={data?.user_image}
                    style={avatarStyle}>
                    {headShotName}
                  </Avatar>
                </Badge>
              ) : (
                <Avatar
                  title={data?.username}
                  className={" header-avatar add-comment-avtar comment-box-img"}
                  user_image={data?.user_image}
                  style={avatarStyle}>
                  {headShotName}
                </Avatar>
              )}
            </Grid>
            <div
              className={
                isMobile ? "mobile-comment-box-body" : "comment-box-body"
              }>
              <div className="d-flex justify-content-space-between align-items-center">
                <Grid>
                  <Typography
                    className={`comment-box-name ${
                      isMobile ? "comment-box-name-text" : ""
                    }`}>
                    {data?.username}
                  </Typography>
                </Grid>
                {!isBetween300And699 && (
                  <Grid>
                    <Typography className="comment-box-date">
                      {<CustomDateFormatter date={data?.comment_time} />}
                    </Typography>
                  </Grid>
                )}
                {isMobile && (<div>
                      <IconButton
                        onClick={(e) => setAnchorEl(e.currentTarget)}
                        className="worklog-menu-button"
                      >
                        <MoreVert />
                      </IconButton>
                      <CustomMenu
                        anchorEl={anchorEl}
                        open={anchorEl}
                        handleClose={() => setAnchorEl(null)}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                        anchorOrigin={{
                          horizontal: "right",
                          vertical: "bottom",
                        }}
                        className="worklog-menu-items"
                      >
                        <CustomMenuItem
                          onClick={handleEdit}
                          className="worklog-menu-items-item"
                        >
                          <EditOutlined className="icon" />
                          Edit
                        </CustomMenuItem>
                        <CustomMenuItem
                          onClick={handleDelete}
                          className="worklog-menu-items-item"
                        >
                          <DeleteOutlined className="icon" />
                          Delete
                        </CustomMenuItem>
                      </CustomMenu>
                    </div>)}
              </div>
              <Grid>
                {showEdit ? (
                  <EditTextFields
                    cardId={cardId}
                    setShowEdit={setShowEdit}
                    comment_id={data?.comment_id}
                    messg={data?.comment}
                  />
                ) : (
                  <WorklogText text={data?.comment} />
                )}
              </Grid>
              {!isMobile && data?.author_id == currentUserId() && !showEdit && (
                <div className="d-flex">
                  <CustomButton
                    className="comment-box-btn1 reset-btn"
                    onClick={handleEdit}>
                    Edit
                  </CustomButton>
                  <CustomButton
                    onClick={() => handleDelete()}
                    className="comment-box-btn2 reset-btn">
                    Delete
                  </CustomButton>
                </div>
              )}

              {isBetween300And699 && (
                <Grid>
                  <Typography
                    className={
                      isMobile ? "mobile-comment-box-date" : "comment-box-date"
                    }>
                    {<CustomDateFormatter date={data?.comment_time} />}
                  </Typography>
                </Grid>
              )}
            </div>
          </div>
        </Grid>
      </Box>
    </>
  );
}

export default React.memo(ListComment);
